import CtaName from '../interfaces/ctaName';

const buttonLabels: CtaName = {
  KEEP_BOX: 'KEEP BOX',
  CANCEL_BOX: 'CANCEL BOX',
  CANCEL: 'CANCEL',
  REACTIVATE: 'REACTIVATE',
  BACK_HOME: 'Back home',
  YES_LEARN_MORE: 'YES, LEARN MORE',
  LEARN_MORE: 'LEARN MORE',
  NO_THANKS: 'No Thanks',
  CONTINUE: 'CONTINUE',
};

export default buttonLabels;
